module.exports = __webpack_public_path__ + "img/Publishing-top.f67bfda5.jpg";